/* eslint-disable max-len */

export const FREQUENT_FAQ_DATA = [
  {
    open: false,
    question: 'What are the Available Payment Methods?',
    answer: `
                  <div _ngcontent-popsy-frontend-c3897527011="" class="rte">
  <p _ngcontent-popsy-frontend-c3897527011=""> We want to make buying your favorite electronics fast and easy, and we accept the following payment options: </p>
  <div _ngcontent-popsy-frontend-c3897527011="" class="methods">
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">Credit cards</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">Visa</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">MasterCard</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">American Express</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">Discover</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">Mada</p><!--container-->
    </div>
    <span _ngcontent-popsy-frontend-c3897527011="" aria-hidden="true" class="fixed-space-12"></span>
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">Wallets</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">Apple Pay</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">Google Pay</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">STC Pay</p><!--container-->
    </div>
    <span _ngcontent-popsy-frontend-c3897527011="" aria-hidden="true" class="fixed-space-12"></span>
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">Buy Now Pay Later, up to 6 installments</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">Tabby</p><!--container-->
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">Tamara</p><!--container-->
    </div><!--container-->
    <span _ngcontent-popsy-frontend-c3897527011="" aria-hidden="true" class="fixed-space-12"></span>
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">Financing Services, up to 36 installments</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">Wataniya</p><!--container-->
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">Quara</p><!--container-->
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">Baseeta</p><!--container-->
    </div><!--container-->
  </div>
  <p _ngcontent-popsy-frontend-c3897527011=""> Please keep in mind that once you've completed the checkout procedure, your order will be handled right away. You'll receive an email confirmation as well as tracking updates to keep track of your order's progress once it's ready to ship. </p>
</div>
 `,
    questionAr: 'ما هي طرق الدفع المتاحة؟',
    answerAr: `
    <div _ngcontent-popsy-frontend-c3897527011="" class="rte">
  <p _ngcontent-popsy-frontend-c3897527011=""> نريد أن نجعل شراء إلكترونياتك المفضلة سريعًا وسهلاً، ونحن نقبل خيارات الدفع التالية: </p>
  <div _ngcontent-popsy-frontend-c3897527011="" class="methods">
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">بطاقات الائتمان</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">فيزا</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">ماستركارد</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">أمريكان إكسبريس</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">ديسكفر</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">مدى</p><!--container-->
    </div>
    <span _ngcontent-popsy-frontend-c3897527011="" aria-hidden="true" class="fixed-space-12"></span>
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">المحافظ الإلكترونية</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">Apple Pay</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">Google Pay</p>
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">STC Pay</p><!--container-->
    </div>
    <span _ngcontent-popsy-frontend-c3897527011="" aria-hidden="true" class="fixed-space-12"></span>
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">اشتر الآن وادفع لاحقًا، حتى 6 أقساط</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">تابي</p><!--container-->
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">تمارة</p><!--container-->
    </div><!--container-->
    <span _ngcontent-popsy-frontend-c3897527011="" aria-hidden="true" class="fixed-space-12"></span>
    <p _ngcontent-popsy-frontend-c3897527011="" class="bold">خدمات التمويل، حتى 36 قسطًا</p>
    <div _ngcontent-popsy-frontend-c3897527011="" class="flex gap-8">
      <p _ngcontent-popsy-frontend-c3897527011="">وطنيّة</p><!--container-->
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">قرض</p><!--container-->
      <p _ngcontent-popsy-frontend-c3897527011="">-</p>
      <p _ngcontent-popsy-frontend-c3897527011="">بيسيتا</p><!--container-->
    </div><!--container-->
  </div>
  <p _ngcontent-popsy-frontend-c3897527011=""> يرجى مراعاة أنه بمجرد اكتمال إجراء الدفع، سيتم التعامل مع طلبك على الفور. ستتلقى تأكيدًا عبر البريد الإلكتروني بالإضافة إلى تحديثات تتبع لمتابعة تقدم طلبك بمجرد أن يصبح جاهزًا للشحن. </p>
</div>
`,
  },
  {
    open: false,
    question: 'How can I track my Order?',
    answer: `
                    <p>We'll send you an Email &amp; SMS (if provided) with your shipment details and tracking number so you can follow your parcel and know exactly when to expect it.</p><p>Can't find your tracking number or your order hasn't been updated?</p><p>You can send us a message at&nbsp;<a href="mailto:support@popsy.app" target="_self">support@popsy.app</a></p>
                    
                  `,
    questionAr: 'كيف يمكنني التحقق من حالة الطلب الخاص بي؟',
    answerAr: `
    
                    <p>سنرسل لك بريدًا إلكترونيًا ورسالة قصيرة (إذا تم توفيرها) مع تفاصيل الشحنة ورقم التتبع الخاص بك حتى تتمكن من متابعة الطرد الخاص بك ومعرفة متى تتوقع وصوله بالضبط.</p><p> لا يمكنك العثور على رقم التتبع الخاص بك أو لم يتم تحديث طلبك ؟ يمكنك إرسال رسالة إلينا على support@popsy.app</p>
                    
   
    `,
  },
  {
    open: false,
    question: 'What are Popsy`s Shipping Options?',
    answer: `
                    <p>Popsy users and guests can select their preferred shipping option during checkout, and we'll provide you an estimated delivery date for each item in your bag based on your shipping choices, the delivery address, and the location of the item(s). The following shipping options are available to you:</p><p><strong>Free Shipping</strong></p><p>5 - 7 days delivery</p><p><strong>Premium Shipping</strong></p><p>3 - 5 days deliveryCost varies depending on delivery location</p><p><em>Please note, premium shipping may not be available for your location, we will give you options during checkout.</em></p>
                    
                  
`,
    questionAr: 'ما هي خيارات الشحن لدى بوبسي؟',
    answerAr: `
    
                    <p>يمكن لمستخدمي Popsy والضيوف تحديد خيار الشحن المفضل لديهم أثناء الدفع، وسنقدم لك تاريخ تسليم تقديري لكل عنصر في عربة التسوق بناءً على خيارات الشحن الخاصة بك وعنوان التسليم وموقع العنصر (العناصر). خيارات الشحن التالية متاحة لك:</p><p></p><p>شحن مجاني</p><p> - توصيل خلال 5 - 7 أيام </p><p>شحن خاص </p><p>- توصيل من 3 - 5 أيام تختلف التكلفة اعتمادًا على موقع التسليم يرجى ملاحظة أن الشحن الخاص قد لا يكون متاحًا لموقعك، وسنمنحك خيارات أثناء الدفع.</p>
                        
    `,
  },
  {
    open: false,
    question: 'What is Popsy`s Free Warranty?',
    answer: `
               <p>Popsy is confident that the devices we offer for sale are in perfect working condition, that is why every device comes with a free 12-month warranty. In case of any defects during the warranty period, we will make sure your device is either repaired or replaced, for free.</p>
                
 `,
    questionAr: 'ما هي ضمان بوبسي المجاني؟',
    answerAr: `
   <p>بوبسي واثقة من أن الأجهزة التي نقدمها للبيع في حالة عمل مثالية، ولهذا السبب يأتي كل جهاز بضمان مجاني لمدة 12 شهرًا. في حالة حدوث أي عيوب خلال فترة الضمان، سوف نتأكد من إصلاح جهازك أو استبداله مجانًا.</p> 
   
    `,
  },
  {
    open: false,
    question: 'What is Popsy`s Return Policy?',
    answer: `
              <p>Every order is 100% Risk-Free. Returns are easy and convenient! Returns are always Free and the return window is 14 days after shipping.</p>
                      `,
    questionAr: 'ما هي سياسة الإرجاع التي تقدمها بوبسي؟',
    answerAr: `
                 <p>كل طلب خالٍ من المخاطر بنسبة 100٪. عملية الإرجاع سهلة ومريحة! عمليات الإرجاع مجانية دائمًا وسياسة الإرجاع تدوم لمدة 14 يومًا بعد الشحن.</p>  
    `,
  },
  {
    open: false,
    question: 'Can I cancel my order?',
    answer: `
          
    <p>If you need to cancel your order, let us know within 24 hours of your purchase. Our team will check if your order has already been shipped. Please note that fees may apply.
</p>
    
    `,
    questionAr: 'هل يمكنني إلغاء طلبي؟',
    answerAr: `
     <p>إذا كنت بحاجة لإلغاء طلبك، يرجى إبلاغنا خلال 24 ساعة من شراءك. سيقوم فريقنا بالتحقق مما إذا كان قد تم شحن طلبك بالفعل. يرجى ملاحظة أنه قد يتم تطبيق رسوم.</p>

    `,
  },
];
